import { format } from '@teetsh/app/src/utils/time/format';
import { getNextDayBasedOnViewAndWorkingDays } from '@teetsh/app/src/utils/time';
import { isoDatePatternWithSlashes } from '@teetsh/app/src/utils/time/datePatterns';
import { CahierJournalView } from 'containers/CahierJournal/types';

export function getNextDateUrl(
  view: CahierJournalView,
  date: Date,
  workingDays: number[],
) {
  const nextDay = getNextDayBasedOnViewAndWorkingDays(view, date, workingDays);
  return `cahier-journal/${view}/${format(
    nextDay,
    'fr-FR',
    isoDatePatternWithSlashes,
  )}`;
}
